export default __webpack_public_path__ + "static/media/gateway.14cf9885.webp";